import React, { useEffect, useState } from "react";
import withStyles from "@mui/styles/withStyles";
import Post from "../post/Post";
import { Button, Input, Typography } from "@mui/material";
import axios from "axios";
import Loading from "../../../../shared/components/Loading";
import Reply from "./Reply";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const styles = (theme) => ({
  replyField: {
    margin: theme.spacing(2, 0),
    background: "transparent",
    width: "100%",
  },

  replyFieldContainer: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
    alignItems: "center",
    padding: "0 1rem",
    // border: "2px solid " + theme.palette.primary.main,
    background: theme.palette.primary.main + "16",
    borderRadius: "8px",
    width: "100%",
  },
});

const RepliesFeed = ({ classes, currentUser, slug, likePost }) => {
  const [content, setContent] = React.useState("");

  const [replies, setReplies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  const postReply = async (content, mentionedUser) => {
    setLoading(true);
    let req = {
      content: content,
      mentionedUser: mentionedUser,
    };
    try {
      const { data: newReply } = await axios.post(
        `/api/socials/replies/create/${slug}`,
        req
      );

      setReplies((prevReplies) => [newReply.reply, ...prevReplies]);
      setContent("");
    } catch (error) {
      console.error("Failed to post reply:", error);
    } finally {
      setLoading(false);
    }
  };

  const getReplyData = async () => {
    if (!hasMore) return;

    setLoading(true);
    try {
      const { data } = await axios.get(
        `/api/socials/replies/get/${slug}?page=${page}&limit=10`
      );

      setReplies((prevReplies) => [...prevReplies, ...data.replies]);
      setPage((prevPage) => prevPage + 1);

      // Check if there are more replies to load
      setHasMore(data.replies.length > 0);
    } catch (error) {
      console.error("Failed to fetch replies:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop + 500 <
          document.documentElement.offsetHeight ||
        loading ||
        !hasMore
      ) {
        return;
      }

      getReplyData();
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    const fetchData = async () => {
      await getReplyData();
      setLoading(false);
    };

    fetchData();
  }, []);

  const handleDeleteReply = async (id) => {
    try {
      setLoading(true);
      await axios.delete(`/api/socials/replies/delete/${id}`);
      await getReplyData();
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  let history = useHistory();
  const goToAuth = () => {
    history.push("/auth/login");
  };

  return (
    <div>
      <div className={classes.replyFieldContainer}>
        <Input
          name="reply"
          className={classes.replyField}
          placeholder="Type Your Reply..."
          value={content}
          onChange={(e) => setContent(e.target.value)}
          disableUnderline
          multiline
        />
        <Button
          variant="contained"
          size="large"
          onClick={() => (currentUser ? postReply(content) : goToAuth())}
        >
          {currentUser ? "Reply" : "Login"}
        </Button>
      </div>

      <div>
        {replies.map((reply, index) => {
          return (
            <Reply
              post={reply}
              currentUser={currentUser}
              handleDeleteReply={handleDeleteReply}
              key={index}
              postReply={postReply}
              goToAuth={goToAuth}
              likePost={likePost}
            />
          );
        })}
        {loading && <Loading item="replies" />}
      </div>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(RepliesFeed);
